// extracted by mini-css-extract-plugin
export var modalFooter = "_sd-0";